
import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function functionChartPerformance({ xlabel, plotdata, tooltip_onpeak, tooltip_offpeak, tooltip_usage, tooltip_ft,
    plotcolor, plotname, chart_style, cod, max, interval,
    unitrate, unitrate_onpeak, unitrate_offpeak, ft_val, holiday, prefix_tool,
    plotcolor2, plotname2, plotdata2, co2factor, errorx }) {

    var error = errorx
    const yformat = chart_style.yformat
    const indexlabel = chart_style.indexlabel
    const xformat = chart_style.xformat
    const tooltip_header = chart_style.tooltip_header
    const tooltip_format = chart_style.tooltip_format
    const plot_buffer = plotdata

    const plot = [
        { color: plotcolor, unit: chart_style.unit, name: plotname, dp: chart_style.digit },
        { color: plotcolor2, unit: chart_style.unit, name: plotname2, dp: chart_style.digit },
    ]

    var cod_strip = []
    if (cod !== null) {
        cod_strip = [
            {
                startValue: new Date(cod.CODIndex_Start),
                endValue: new Date(cod.CODIndex_Stop),
                color: "#d8d8d8"
            }
        ]
    }
    const unit_rate = unitrate
    const unit_rate_onpeak = unitrate_onpeak
    const unit_rate_offpeak = unitrate_offpeak
    const co2_factor = co2factor

    var xoverlap_startxx = 0
    if (window.screen.width < 576) {
        if (xformat.includes(":mm")) {
            xoverlap_startxx = 3
        } else if (xformat.includes("YYYY")) {
            if (plot_buffer !== undefined) {
                if (plot_buffer.length !== undefined) {
                    const syear = Number(moment(new Date(plot_buffer[0].x)).format("YYYY"))
                    xoverlap_startxx = syear - 1
                }
            }
        }
    }

    const options = {
        height: 235,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (e.entries[0].dataPoint !== undefined) {
                    var txt_holiday = ""
                    if (holiday !== undefined) {
                        if (holiday[e.entries[0].index] !== undefined && holiday[e.entries[0].index] === true) {
                            txt_holiday = '(Holiday)'
                        }
                    }

                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">' + tooltip_header + ' : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format(tooltip_format) + " " + txt_holiday + ' </p>'
                    if (e.entries[0].dataSeries.name === "Estimate Saving" || e.entries[0].dataSeries.name === "Estimate Energy Value") {
                        if (e.entries[0] !== undefined) {
                            if (e.entries[0].index !== undefined) {
                                if (unit_rate !== undefined) {
                                    if (unit_rate[e.entries[0].index] !== undefined) {
                                        elem += '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">Unit Rate : ' + unit_rate[e.entries[0].index] + ' Baht/kWh</p>'
                                    }
                                }
                                if (unit_rate_onpeak !== undefined) {
                                    if (unit_rate_onpeak[e.entries[0].index] !== undefined) {
                                        elem += '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">Unit Rate On-Peak : ' + unit_rate_onpeak[e.entries[0].index] + ' Baht/kWh</p>'
                                    }
                                }
                                if (unit_rate_offpeak !== undefined) {
                                    if (unit_rate_offpeak[e.entries[0].index] !== undefined) {
                                        elem += '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">Unit Rate Off-Peak : ' + unit_rate_offpeak[e.entries[0].index] + ' Baht/kWh</p>'
                                    }
                                }
                                if (ft_val !== undefined) {
                                    if (ft_val[e.entries[0].index] !== undefined) {
                                        elem += '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">FT Charge Rate : ' + ft_val[e.entries[0].index] + ' Baht/kWh</p>'
                                    }
                                }
                            }
                        }
                    }
                    if (e.entries[0].dataSeries.name === "CO2 Reduction") {
                        if (e.entries[0] !== undefined) {
                            if (e.entries[0].index !== undefined) {
                                if (co2_factor[e.entries[0].index] !== undefined) {
                                    elem += '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">CO<sub>2</sub> Factor : ' + co2_factor[e.entries[0].index] + ' kgCO<sub>2</sub>/1kWh</p>'
                                }
                            }
                        }
                    }
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                var value = ""
                                if (e.entries[i].dataPoint.y > 0) {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                } else {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                }
                                elem += '<div class="measure-rows font-bold">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + value + '</div>' +
                                    '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                                if (e.entries[0].dataSeries.name === "Solar Energy" || e.entries[0].dataSeries.name === "Estimate Saving" || e.entries[0].dataSeries.name === "Estimate Energy Value") {
                                    if (tooltip_onpeak !== undefined) {
                                        var v_on = ""
                                        if (tooltip_onpeak[e.entries[0].index] > 0) {
                                            v_on = tooltip_onpeak[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                        } else {
                                            v_on = tooltip_onpeak[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                        }
                                        elem += '<div class="measure-rows font-bold">' +
                                            '<div class="measure-cell" style = "color:black;font-size: 11px !important;min-width:150px  !important;">On-Peak ' + prefix_tool + '</div>' +
                                            '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + v_on + '</div>' +
                                            '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                            '</div>'
                                    }
                                    if (tooltip_offpeak !== undefined) {
                                        var v_off = ""
                                        if (tooltip_offpeak[e.entries[0].index] > 0) {
                                            v_off = tooltip_offpeak[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                        } else {
                                            v_off = tooltip_offpeak[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                        }
                                        elem += '<div class="measure-rows font-bold">' +
                                            '<div class="measure-cell" style = "color:black;font-size: 11px !important;min-width:150px  !important;">Off-Peak ' + prefix_tool + '</div>' +
                                            '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + v_off + '</div>' +
                                            '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                            '</div>'
                                    }
                                    if (tooltip_usage !== undefined) {
                                        var v_off = ""
                                        if (tooltip_usage[e.entries[0].index] > 0) {
                                            v_off = tooltip_usage[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                        } else {
                                            v_off = tooltip_usage[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                        }
                                        elem += '<div class="measure-rows font-bold">' +
                                            '<div class="measure-cell" style = "color:black;font-size: 11px !important;min-width:150px  !important;">Energy Price ' + prefix_tool + '</div>' +
                                            '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + v_off + '</div>' +
                                            '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                            '</div>'
                                    }
                                    if (tooltip_ft !== undefined) {
                                        var v_off = ""
                                        if (tooltip_ft[e.entries[0].index] > 0) {
                                            v_off = tooltip_ft[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                        } else {
                                            v_off = tooltip_ft[e.entries[0].index].toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                        }
                                        elem += '<div class="measure-rows font-bold">' +
                                            '<div class="measure-cell" style = "color:black;font-size: 11px !important;min-width:150px  !important;">FT Charged ' + prefix_tool + '</div>' +
                                            '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + v_off + '</div>' +
                                            '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                            '</div>'
                                    }
                                }
                            }
                        }
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 'normal',
            horizontalAlign: "left"
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 12,
            fontWeight: 'normal',
            cursor: "pointer",
            fontColor: '#000',
            horizontalAlign: "center", // "center" , "right"
            verticalAlign: "top",  // "top" , "bottom"
        },
        axisX: {
            interval: 1,
            intervalType: chart_style.xinterval,
            labelFormatter: function (e) {
                if (window.screen.width < 576) {
                    const sxs = moment(new Date(e.value)).format(xformat.replaceAll(":mm", "").replaceAll("MMM", "MM"))
                    const nx = Number(sxs - xoverlap_startxx)
                    if (nx >= 1 && nx % 2 === 0) {
                        return ""
                    }
                }
                return moment(new Date(e.value)).format(xformat)
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: 'poppins',
            labelFontSize: 10,
            title: xlabel,
            margin: 0,
            crosshair: {
                enabled: true,
                snapToDataPoint: true,
                color: "orange",
                labelFontColor: "#F8F8F8",
                labelBackgroundColor: "#1A5276",
            },
            minimum: chart_style.start,
            stripLines: cod_strip,
        },
        axisY: [{
            title: chart_style.axis_y1,
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "Inter",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "#AEB6BF",
            margin: 0,
            minimum: 0,
            maximum: max,
            interval: interval,
            valueFormatString: chart_style.yformat
        }],
        data: [
            {
                type: chart_style.type,
                markerType: "circle",
                markerSize: 0,
                name: plotname,
                color: plotcolor,
                axisYIndex: 0,
                dataPoints: plotdata,
                lineThickness: 2,
                indexLabelFontSize: 10,
                indexLabelFontWeight: "bold",
                indexLabelFontFamily: 'poppins',
                indexLabelOrientation: indexlabel,
                indexLabelFormatter:
                    function (e) {
                        if (window.screen.width < 576) {
                            return ""
                        }
                        if (indexlabel !== "-") {
                            if (e.dataPoint.y !== undefined) {
                                var error_code = ""
                                const index = e.dataSeries.dataPoints.findIndex(item => item.x === e.dataPoint.x);
                                if ((e.dataSeries.name === "Energy not Supply" || e.dataSeries.name === "Operation Ratio" || e.dataSeries.name === "Performance Ratio") && error !== null && error !== undefined) {
                                    if (error[index] !== undefined) {
                                        if (error[index]) {
                                            error_code = "\u274C"
                                        }
                                    }
                                }
                                if (e.dataSeries.name !== "Operation Ratio" && e.dataSeries.name !== "Performance Ratio") {
                                    if (e.dataPoint.y > 0) {
                                        var Demo = ""
                                        if (yformat !== undefined) {
                                            if (yformat === '#0.###,.k') {
                                                return Demo + (e.dataPoint.y / 1000).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + 'k'
                                            } else if (yformat === '#0.###,.,.M') {
                                                return Demo + (e.dataPoint.y / 1000000).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'M'
                                            }
                                        }
                                        return Demo + e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                                    }
                                    return error_code + e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                } else {
                                    if (e.dataPoint.y >= 100 || e.dataPoint.y === 0) {
                                        return error_code + e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                    } else {
                                        return error_code + e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    }
                                }
                            }
                        }
                        return ""
                    }
            },
            {
                type: 'line',
                markerType: "circle",
                markerSize: 0,
                name: plotname2,
                color: plotcolor2,
                axisYIndex: 0,
                dataPoints: plotdata2,
                lineThickness: 2,
            }]
    }

    return (
        <div className="dashboard-chart-wrapper">
            <CanvasJSChart options={options}
            />
        </div>
    );
}
